import React from "react";
import { connect } from "react-redux";
import validator from "validator";

import { getStrValue, isA, isReporter } from "../../store/utility";

import axios from "../../axios-atis";

import withErrorHandler from "../../hoc/withErrorHandler/withErrorHandler";
import { fetchUser /*, updateUser*/ } from "../../store/actions/index";

import {
  Form,
  FormControl,
  InputGroup,
  FormGroup,
  ControlLabel,
  Row,
  Col,
  Button,
} from "react-bootstrap";
import Switch from "rc-switch";
import "rc-switch/assets/index.css";
import * as UIConstants from "../../components/UI/UIConstants";

class User extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      user: this.props.user,
      originalUser: this.props.user,
      loading: false,
      error: null,
      title: {
        value: this.getPropValue(["user", "title"]),
        isValid: true,
        message: "",
        defaultValue: "",
      },
      forname: {
        value: this.getPropValue(["user", "forname"]),
        isValid: true,
        message: "",
        defaultValue: "Prénom",
      },
      name: {
        value: this.getPropValue(["user", "name"]),
        isValid: true,
        message: "",
        defaultValue: "Nom",
      },
      username: {
        value: this.getPropValue(["user", "username"]),
        isValid: true,
        message: "",
        defaultValue: "Login",
      },
      email: {
        value: this.getPropValue(["user", "email"]),
        isValid: true,
        message: "",
        defaultValue: "Adresse électronique",
      },
      phone: {
        value: this.getPropValue(["user", "phone"]),
        isValid: true,
        message: "",
        defaultValue: "Téléphone fixe",
      },
      cellular: {
        value: this.getPropValue(["user", "cellular"]),
        isValid: true,
        message: "",
        defaultValue: "Téléphone portable",
      },
      appKey: {
        value: this.getPropValue(["user", "appKey"]),
        isValid: true,
        message: "",
        defaultValue: "",
      },
      changeKey: false,
      generateAppKey: null,
      activated: {
        value: this.getPropValue(["user", "activated"]),
        isValid: true,
        message: "",
        defaultValue: "",
      },
      role: { value: null, isValid: true, message: "", defaultValue: "" },
      company: { value: null, isValid: true, message: "", defaultValue: "" },
      pwd1: { value: "", isValid: true, message: "" },
      pwd2: { value: "", isValid: true, message: "" },
    };
    this.inputChangeHandler.bind(this);
    this.validateForm.bind(this);
    this.submitHandler.bind(this);
  }
  getPropValue = (args) => {
    var previousObj = undefined;
    for (var i = 0; i < args.length; i++) {
      if (/*null === previousObj || */ !previousObj) {
        previousObj = this.props[args[i]];
      } else {
        previousObj = previousObj[args[i]];
      }
      if (previousObj === null || previousObj === undefined) {
        return "";
      }
    }

    return previousObj;
  };

  inputChangeHandler = (event) => {
    var _state = this.state;
    _state[event.target.id].value = event.target.value;
    this.setState(_state);
  };
  changeActivatedInputHandler = (value) => {
    var _state = this.state;
    _state.activated.value = value;
    this.setState(_state);
  };
  /*validateForm = event => {
        return false;
    }
    submitHandler = event => {
        event.preventDefault();
        //TO DO : state property to user
        //this.props.dispatch(updateUser(this.state.user));
    }*/

  resetValidationStates = () => {
    var state = this.state;

    Object.keys(state).map((key) => {
      if (state[key].hasOwnProperty("isValid")) {
        state[key].isValid = true;
        state[key].message = "";
      }
      return true;
    });
    this.setState(state);
  };

  formIsValid = () => {
    var state = this.state;

    if (!validator.isLength(state.username.value, 6)) {
      state.username.message = "Au moins 6 caractères";
      state.username.isValid = false;
    } else {
      let url = "/users/check";
      const checkUserNameData = {
        username: state.username.value,
      };
      axios
        .post(url, checkUserNameData)
        .then((response) => {
          if (response.data.status !== 202) {
            state.username.message = response.data.message;
            state.username.isValid = false;
          }
        })
        .catch((error) => {
          state.username.message = "Erreur technique";
          state.username.isValid = false;
        });
    }

    if (!validator.isLength(state.pwd1.value, 8)) {
      state.pwd1.message = "Au moins 8 caractères";
      state.pwd1.isValid = false;
    }
    if (state.pwd1.value !== state.pwd2.value) {
      state.pwd2.message = "Les mots de passe sont différents";
      state.pwd2.isValid = false;
    }
    if (!validator.isEmail(state.email.value)) {
      state.email.message = "Format Email incorrecte";
      state.email.isValid = false;
    }

    this.setState(state);
    var isValid = true;
    Object.keys(state).map((key) => {
      if (state[key].hasOwnProperty("isValid")) {
        if (!state[key].isValid) {
          isValid = false;
        }
      }
      return true;
    });

    return isValid;
  };

  validateForm = () => {
    if (
      this.state.username.value.length > 0 &&
      this.state.pwd1.value.length > 0 &&
      this.state.pwd2.value.length
    ) {
      return true;
    }
    return false;
  };

  submitHandler = (event) => {
    event.preventDefault();
    this.resetValidationStates();
    this.formIsValid();
  };

  componentWillReceiveProps(nextProps) {
    if (
      this.state.loading &&
      !nextProps.loading &&
      nextProps.user &&
      null === nextProps.error &&
      null !== nextProps.user
    ) {
      var _state = this.state;
      _state.loading = nextProps.loading;
      _state.user = nextProps.user;
      _state.originalUser = nextProps.user;
      _state.title.value = getStrValue(nextProps.user.title);
      _state.forname.value = getStrValue(nextProps.user.forname);
      _state.name.value = getStrValue(nextProps.user.name);
      _state.username.value = getStrValue(nextProps.user.username);
      _state.email.value = getStrValue(nextProps.user.email);
      _state.phone.value = getStrValue(nextProps.user.phone);
      _state.cellular.value = getStrValue(nextProps.user.cellular);
      _state.appKey.value = getStrValue(nextProps.user.appKey);
      _state.activated.value = nextProps.user.activated;
      _state.pwd1.value = "";
      _state.pwd2.value = "";
      this.setState(_state);
    }
  }
  componentDidMount() {
    this.props.dispatch(fetchUser(this.state.user));
    this.setState({ loading: true, user: null });
  }

  generateKey = () => {
    var state = this.state;
    let url = "/users/generateKey";
    axios
      .post(url)
      .then((response) => {
        state.generateAppKey = response.data;
      })
      .catch((err) => {
        state.generateAppKey = null;
      });
    this.setState(state);
  };
  appKeyChangeHandler = (event) => {
    event.preventDefault();
    var val = this.state.changeKey;
    this.setState({ changeKey: !val });
  };

  render() {
    if (null === this.state.user) {
      return null;
    }

    return (
      <div className="content-wrapper">
        <Row className="form-group content-heading">
          <Col md={8}>Mon compte</Col>
          <Col md={4} />
        </Row>
        <Form onSubmit={this.submitHandler} horizontal>
          <FormGroup>
            <Col componentClass={ControlLabel} sm={2}>
              Titre
            </Col>
            <Col sm={2}>
              <FormControl
                componentClass="select"
                id="title"
                value={getStrValue(this.state.title.value)}
                onChange={(event) => this.inputChangeHandler(event)}
              >
                {UIConstants.USER_TITLE.map((title, index) => {
                  return (
                    <option key={index} value={title.name}>
                      {title.label}
                    </option>
                  );
                })}
                ;
              </FormControl>
            </Col>
            {this.state.user.id === null || isA() || isReporter() ? (
              <Col sm={8}>
                <div className="pull-right">
                  Actif{" "}
                  <Switch
                    checked={this.state.activated.value}
                    onChange={(value) =>
                      this.changeActivatedInputHandler(value)
                    }
                  />
                </div>
              </Col>
            ) : null}
          </FormGroup>
          <FormGroup>
            <Col componentClass={ControlLabel} sm={2}>
              Prénom
            </Col>
            <Col sm={4}>
              <FormControl
                type="text"
                id="forname"
                onChange={(event) => this.inputChangeHandler(event)}
                value={getStrValue(this.state.forname.value)}
                placeholder={this.state.forname.defaultValue}
              />
            </Col>
            <Col componentClass={ControlLabel} sm={2}>
              Nom
            </Col>
            <Col sm={4}>
              <FormControl
                type="text"
                id="name"
                onChange={(event) => this.inputChangeHandler(event)}
                value={getStrValue(this.state.name.value)}
                placeholder={this.state.name.defaultValue}
              />
            </Col>
          </FormGroup>
          <FormGroup>
            <Col componentClass={ControlLabel} sm={2}>
              Email
            </Col>
            <Col sm={10}>
              <InputGroup>
                <InputGroup.Addon>@</InputGroup.Addon>
                <FormControl
                  type="text"
                  id="email"
                  onChange={(event) => this.inputChangeHandler(event)}
                  value={getStrValue(this.state.email.value)}
                  placeholder={this.state.email.defaultValue}
                />
              </InputGroup>
            </Col>
          </FormGroup>
          <FormGroup>
            <Col sm={2} />
            <Col sm={5}>
              <InputGroup>
                <InputGroup.Addon>
                  <span className="fa fa-phone" />
                </InputGroup.Addon>
                <FormControl
                  type="text"
                  id="phone"
                  onChange={(event) => this.inputChangeHandler(event)}
                  value={getStrValue(this.state.phone.value)}
                  placeholder={this.state.phone.defaultValue}
                />
              </InputGroup>
            </Col>
            <Col sm={5}>
              <InputGroup>
                <InputGroup.Addon>
                  <span className="fa fa-mobile-phone" />
                </InputGroup.Addon>
                <FormControl
                  type="text"
                  id="cellular"
                  onChange={(event) => this.inputChangeHandler(event)}
                  value={getStrValue(this.state.cellular.value)}
                  placeholder={this.state.cellular.defaultValue}
                />
              </InputGroup>
            </Col>
          </FormGroup>
          <FormGroup>
            <Col componentClass={ControlLabel} sm={2}>
              Login
            </Col>
            <Col sm={4}>
              <InputGroup>
                <InputGroup.Addon>
                  <span className="fa fa-user" />
                </InputGroup.Addon>
                <FormControl
                  type="text"
                  id="username"
                  onChange={(event) => this.inputChangeHandler(event)}
                  value={getStrValue(this.state.username.value)}
                  placeholder={this.state.username.defaultValue}
                  disabled={this.state.user.id !== null}
                />
              </InputGroup>
            </Col>
            {isA() || isReporter() ? (
              <Col componentClass={ControlLabel} sm={2}>
                Role
              </Col>
            ) : null}
            {isA() || isReporter() ? (
              <Col sm={4}>
                <FormControl
                  componentClass="select"
                  id="role"
                  value={getStrValue(this.state.role.value)}
                  onChange={(event) => this.inputChangeHandler(event)}
                >
                  {UIConstants.USER_ADMIN_ROLES.foreach((index, role) => {
                    return (
                      <option key={index} value={role.name}>
                        {role.label}
                      </option>
                    );
                  })}
                  ;
                </FormControl>
              </Col>
            ) : null}
          </FormGroup>
          {isA() ? (
            <FormGroup>
              <Col componentClass={ControlLabel} sm={2}>
                Clé android :
              </Col>
              <Col sm={6}>
                <FormControl
                  type="text"
                  id="appKey"
                  value={getStrValue(
                    this.state.generateAppKey === null
                      ? ""
                      : this.state.generateAppKey
                  )}
                  placeholder="Clé application Androïd"
                  disabled={true}
                />
              </Col>
              <Col sm={2}>
                <FormControl
                  type="checkbox"
                  onChange={(event) => this.appKeyChangeHandler(event)}
                  disabled={this.state.appKey.value === ""}
                />
              </Col>
              <Col sm={2}>
                <Button
                  onClick={this.generateKey()}
                  disabled={this.state.changeKey}
                />
              </Col>
            </FormGroup>
          ) : null}
          <FormGroup>
            <Col componentClass={ControlLabel} sm={2}>
              Mot de passe
            </Col>
            <Col sm={5}>
              <FormControl
                type="password"
                id="pwd"
                placeholder="Mot de passe"
                className="form-control"
                value={this.state.pwd.value}
                onChange={(event) => this.inputChangeHandler(event)}
              />
            </Col>
            {!this.state.changePwd ? (
              <Col sm={2}>
                <Button onChange={(event) => this.changePwd(event)}>
                  Changer
                </Button>
              </Col>
            ) : null}
          </FormGroup>
          )}
          {this.state.changePwd ? (
            <FormGroup>
              <Col componentClass={ControlLabel} sm={2}>
                Mot de passe *
              </Col>
              <Col sm={5}>
                <FormControl
                  type="password"
                  id="pwd1"
                  placeholder="Nouveau mot de passe"
                  className="form-control"
                  value={this.state.pwd1.value}
                  onChange={(event) => this.inputChangeHandler(event)}
                />
                <span style={UIConstants.ERROR_SPAN_STYLE}>
                  {this.state.pwd1.message}
                </span>
              </Col>
              <Col sm={5}>
                <FormControl
                  type="password"
                  id="pwd2"
                  placeholder="vérification nouveau mot de passe"
                  className="form-control"
                  value={this.state.pwd2.value}
                  onChange={(event) => this.inputChangeHandler(event)}
                />
                <span style={UIConstants.ERROR_SPAN_STYLE}>
                  {this.state.pwd2.message}
                </span>
              </Col>
            </FormGroup>
          ) : null}
          <Button
            type="submit"
            disabled={!this.validateForm}
            className="btn btn-block btn-primary mt-lg"
          >
            <span className="fa fa-user" />
            &nbsp;
            {this.state.user.id === null ? "Créer" : "Mettre-à-jour"}
          </Button>
        </Form>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    user: state.user.user,
    error: state.user.error,
    loading: state.user.loading,
  };
};
export default connect(mapStateToProps)(withErrorHandler(User, axios));



// WEBPACK FOOTER //
// ./src/containers/User/User.js